// custom typefaces
import "./src/globals.css"

import { wrapRootElement as wrap } from "./wrapRootElement"

export const wrapRootElement = wrap
